import { render } from "./Business.vue?vue&type=template&id=0cd0c3e4&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"

import "./Business.vue?vue&type=style&index=0&id=0cd0c3e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd0c3e4"]])

export default __exports__